import { render, staticRenderFns } from "./password-update.vue?vue&type=template&id=15099d14&"
import script from "./password-update.vue?vue&type=script&lang=js&"
export * from "./password-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports